class GalleryModel {
  snapshots: string[];
  previewSnapshotIndex: number;
  constructor() {
    this.snapshots = [];
    this.previewSnapshotIndex = 0;
  }

  addSnapshot(b64: string) {
    if (b64.length > 0) {
      this.snapshots.push(b64);
      console.log('addSnapshot:' + this.snapshotsSize());
    }
  }

  latestSnapshot() {
    let b64: string;
    const sz = this.snapshots.length;
    if (sz > 0) {
      b64 = this.snapshots[sz - 1];
    }
    return b64;
  }

  snapshotsSize() {
    return this.snapshots.length;
  }

  previewSnapshot() {
    const index = this.previewSnapshotIndex;
    if (index >= 0 && index < this.snapshotsSize()) {
      return this.snapshots[index];
    }
  }

  onNextSnapshot() {
    const index = this.previewSnapshotIndex + 1;
    if (index < this.snapshotsSize()) {
      this.previewSnapshotIndex = index;
    }
  }

  onPrevSnapshot() {
    const index = this.previewSnapshotIndex - 1;
    if (index >= 0 && index < this.snapshotsSize()) {
      this.previewSnapshotIndex = index;
    }
  }

  onDeleteSnapshot() {
    let index = this.previewSnapshotIndex;
    if (index >= 0 && index < this.snapshotsSize()) {
      this.snapshots.splice(index, 1);
    }
    if (index >= this.snapshotsSize()) {
      --index;
      this.previewSnapshotIndex = index >= 0 ? index : 0;
    }
  }

  isPrevAvailable() {
    const index = this.previewSnapshotIndex;
    return index > 0 && index < this.snapshotsSize();
  }

  isNextAvailable() {
    const index = this.previewSnapshotIndex;
    return index >= 0 && index < this.snapshotsSize() - 1;
  }

  deleteSnapshot(index: number) {
    if (index >= 0 && index < this.snapshotsSize()) {
      // update current index when image deleted
      if (index < this.previewSnapshotIndex) {
        this.snapshots.splice(index, 1);
        --this.previewSnapshotIndex;
      } else if (index === this.previewSnapshotIndex) {
        this.onDeleteSnapshot();
      } else {
        this.snapshots.splice(index, 1);
      }
    }
  }

  setSnapshotPreviewIndex(index: number) {
    let ret = false;
    if (index >= 0 && index < this.snapshotsSize()) {
      this.previewSnapshotIndex = index;
      ret = true;
    }
    return ret;
  }
}

const galleryModel = new GalleryModel();

export default galleryModel;
